module.exports = __webpack_public_path__ + "img/upload.ec086024.svg";